/**
 * Shared avatar utilities used by EmailList and ReadingPane.
 */

export const AVATAR_COLORS = [
  '#0f6cbd', '#107c10', '#c50f1f', '#7719aa', '#e3008c',
  '#038387', '#ca5010', '#0078d4', '#40724a', '#8764b8',
];

export function getAvatarColor(name = '') {
  let h = 0;
  for (let i = 0; i < name.length; i++) h = name.charCodeAt(i) + ((h << 5) - h);
  return AVATAR_COLORS[Math.abs(h) % AVATAR_COLORS.length];
}

export function getInitials(name = '') {
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}
